import React from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectFade, Autoplay, Navigation } from 'swiper/modules';
import servicesData from '../../../data/services-data';

const Services = () => {
    const slideControl = {
        spaceBetween: 25,
        slidesPerView: 4,
        speed: 1000,
        loop: true,
        autoplay: {
            delay: 4000,
            reverseDirection: false,
            disableOnInteraction: false,
        },
        navigation: {
            nextEl: ".service_next",
            prevEl: ".service_prev",
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 2,
            },
            1025: {
                slidesPerView: 4,
            },
            1600: {
                slidesPerView: 4,
            },
        },
    };

    return (
        <div className="services__one" style={{ paddingTop: "120px" }}>
            <div className="container">
                
                {/* TITLE */}
                <div className="row al-end">
                    <div className="col-lg-8">
                        <div className="services__one-title lg-t-center lg-mb-20">
                            <span className="subtitle wow fadeInLeft" data-wow-delay=".4s">
                                FAALİYET ALANLARI
                            </span>

                            <h2
                                className="wow fadeInRight"
                                data-wow-delay=".6s"
                                style={{ fontSize: "36px" }}
                            >
                                Uzmanlık Alanlarımız
                            </h2>
                        </div>
                    </div>

                    <div className="col-lg-4 wow fadeInDown" data-wow-delay=".4s">
                        <div className="slider-arrow jc-end lg-jc-center mb-10">
                            <div className="slider-arrow-prev service_prev">
                            <i class="fa-regular fa-angle-left"></i>
                            </div>
                            <div className="slider-arrow-next service_next">
                            <i class="fa-regular fa-angle-right"></i>
                            </div>
                        </div>
                    </div>
                </div>

                {/* SLIDER */}
                <div className="row mt-60 wow fadeInUp data_cursor" data-wow-delay=".5s" data-cursor-text="Drag">
                    <div className="col-xl-12">

                        <Swiper modules={[EffectFade, Autoplay, Navigation]} {...slideControl}>

                            {servicesData?.map((data, id) => (
                                <SwiperSlide key={id}>

                                    {/* 🔥 CENTERED CARD */}
                                    <div
                                        className="services__one-item"
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            textAlign: "center",
                                            height: "280px",
                                            cursor: "default"
                                        }}
                                    >
                                        <div style={{ fontSize: "48px", marginBottom: "20px" }}>
                                            {data.icon}
                                        </div>

                                        <h4 style={{ margin: 0, fontSize: "18px", lineHeight: "28px", marginTop: 6 }}>
                                            <Link
                                                to={`/services/${data.id}`}
                                                style={{
                                                    pointerEvents: "none",
                                                    textDecoration: "none",
                                                    color: "inherit",
                                                    cursor: "default"
                                                }}
                                            >
                                                {data.title}
                                            </Link>
                                        </h4>
                                    </div>

                                </SwiperSlide>
                            ))}

                        </Swiper>

                    </div>
                </div>

            </div>
        </div>
    );
};

export default Services;